export default "__VITE_ASSET__DwE6FwpA__"